// エラーデータ
type ErrorData = {
  code: string
  message?: string
  key: string
}

// エラーコード定義一覧
const ERROR_CODE = {
  INVALID: {
    USERNAME: {
      code: 'ERROR_INVALID_VALUE_USERNAME',
      message: 'ユーザー名入力チェックエラー',
    },
    PASSWORD: {
      code: 'ERROR_INVALID_VALUE_PASSWORD',
      message: 'パスワード入力チェックエラー',
      key: 'error.invalid.value.password',
    },
    ONETIMEPASS: {
      code: 'ERROR_INVALID_VALUE_ONETIMEPASS',
      message: 'ワンタイムパスワード入力チェックエラー',
      key: 'error.invalid.value.onetimepass',
    },
    TYPE: {
      code: 'ERROR_INVALID_VALUE_TYPE',
      message: '処理種別入力チェックエラー',
      key: 'error.invalid.value.type',
    },
    PASSWORD2: {
      code: 'ERROR_INVALID_VALUE_PASSWORD2',
      message: 'パスワード確認入力チェックエラー',
      key: 'error.invalid.value.password2',
    },
  },
  AUTHENTICATION: {
    BADCREDENTIALS: {
      code: 'ERROR_INVALID_AUTHENTICATION_BADCREDENTIALS',
      message: '認証エラー',
      key: 'error.invalid.authentication.badcredentials',
    },
    LOCKED: {
      code: 'ERROR_INVALID_AUTHENTICATION_LOCKED',
      message: 'アカウントロック',
      key: 'error.invalid.authentication.locked',
    },
    CREDENTIALSEXPIRED: {
      code: 'ERROR_INVALID_AUTHENTICATION_CREDENTIALSEXPIRED',
      message: 'ワンタイムパスワード有効期限切れ',
      key: 'error.invalid.authentication.credentialsexpired',
    },
  },
  DOWNLOAD: {
    NODATA: {
      code: 'ERROR_NO_KEY_DATA',
      message: 'ダウンロードキーに該当するデータが存在しない、または期限切れ、回数オーバー',
      key: 'error.no.key.data',
    },
  },
  INTERNAL: {
    DB: {
      code: 'ERROR_INTERNAL',
      message: 'DBエラー',
    },
    TIMEOUT: {
      code: 'ERROR_INTERNAL',
      message: 'データ取得タイムアウト',
      key: 'error.internal.timeout',
    },
  },
  SYSTEM: {
    // frontend側で何かしらの異常。データ取得できない等
    OTHER: {
      code: 'ERROR_SYSTEM_OTHER',
      message: 'DBエラー',
      key: 'error.system.other',
    },
    // 予期せぬ操作を実施
    UNEXPECTED: {
      code: 'ERROR_SYSTEM_UNEXPECTED',
      message: 'フロー以外の操作を実施',
      key: 'error.system.unexpected',
    },
  },
  AUTH: {
    EXPIRED: {
      code: 'LOGIN_EXPIRED',
      key: 'error.auth.expired',
    },
  },
} as const

// エラーコードに対する紐付けデータ
type ErrorLinkingData = {
  // コード
  code: string
  // リソースキー
  key: string
  // メッセージ(使用しない)
  message?: string
  // 紐づくi18nキー一覧
  keys: Array<string>
}

// エラーコード紐付け定義一覧
const ErorrLinkingKey: Array<ErrorLinkingData> = [
  {
    code: 'ERROR_NO_KEY_DATA',
    key: 'error.no.key.data',
    message: 'ダウンロードキーに該当するデータが存在しない、または期限切れ、回数オーバ',
    keys: [
      'error.no.key.linking.message1',
      'error.no.key.linking.message2',
      'error.no.key.linking.message3',
      'error.no.key.linking.message4',
      'error.no.key.linking.message5',
    ],
  },
]

/**
 * 指定したコードに対したエラーコードに対する紐付けデータを取得する
 * @param code 検索コード
 * @returns 紐付けデータ
 */
const getErrorLinkingData = (code: string) => ErorrLinkingKey.find((p) => p.code === code)

export default ERROR_CODE
export { ErrorData, ErorrLinkingKey, ErrorLinkingData, getErrorLinkingData }
